import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  namespaced: true,
  state() {
    return {
      schedulesList: [],
      currentSchedule: [],
      // {
      //   seasonId: 's1',
      //   weekNumber: 1,
      //   points: 1,
      //   gameId: 1,
      //   home: null,
      //   visitor: null,
      //   winner: null,
      // },
    }
  },
  mutations,
  actions,
  getters,
};